import React from 'react'
import clsx from 'clsx'

import { getLabel } from 'helpers/language'

export interface InputGroupProps {
  children: React.ReactNode
  error?: string
  className?: string
  variants?: 'primary' | 'secondary' | 'ternary'
}

function InputGroup(props: InputGroupProps): JSX.Element {
  const { children, className, error, variants = 'primary' } = props

  const cn = clsx('input-group', className)

  return (
    <div className={cn}>
      <div
        className={clsx(
          'input-group__container',
          `input-group__container--${variants}`,
          error && 'input-group__error',
        )}
        data-testid='input-group-container'
      >
        {children}
      </div>

      {error && (
        <span
          className='input-group__message-error'
          data-testid='input-group-error'
        >
          {getLabel(error)}
        </span>
      )}
    </div>
  )
}

export default InputGroup
